import { IoMdSend } from "react-icons/io";

import { storage } from "@Firebase/firebase";
import IconButton from "@Components/IconButton";
import TextArea from "@Components/Inputs/TextArea";
import FileInputButton from "@Components/FileInputButton";

import styles from "./AddDescription.module.scss";
import {
  handleInteraction,
  handleInteractionDocuments,
} from "../SupportMachine/stateMachineInteractions";
import { CommonProps, TicketFile } from "../SupportMachine/types";

export default function AddDescription({
  state,
  setState,
  text,
  setText,
}: CommonProps) {
  const handleAddDescription = (newText: string) => {
    if (newText) {
      handleInteraction({
        description: newText,
        prevState: state,
        optionIndex: 0,
        currentState: state.name,
        setState,
      });
      setText("");
    }
  };

  const handleAddDocument = (file: TicketFile) => {
    handleInteractionDocuments(file, state, setState);
  };
  const handleUploadDocument = (file: File) => {
    const uploadTask = storage.ref(`/tickets/${file.name}`).put(file);

    uploadTask.on("state_changed", () => {
      const ref = storage.ref("/tickets").child(file.name);

      ref.getDownloadURL().then((fireBaseUrl) => {
        ref.getMetadata().then((metadata) => {
          handleAddDocument({
            url: fireBaseUrl,
            name: file.name,
            metadata,
          });
        });
      });
    });
  };

  return (
    <div className={styles.root}>
      <div className={styles.textArea}>
        <TextArea
          showPlaceHolderTop={false}
          required
          id="description"
          value={text}
          placeholder="Add description"
          onChange={(e) => setText(e.target.value)}
        />
        <FileInputButton onChange={handleUploadDocument} />
        <IconButton onClick={() => handleAddDescription(text)}>
          <IoMdSend size={35} fill="#6b97f6" />
        </IconButton>
      </div>
      {state.ticketData.files.length > 0 && (
        <div className={styles.files}>
          {state.ticketData.files.map((file) => (
            <div key={file.name} className={styles.file}>
              {file.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
